


import { createAction as ngrxCreateAction, props, Action } from '@ngrx/store';

export const INIT_SCREEN = '[Master masterHome] Init';
export const DESTROY_SCREEN = '[Master masterHome] Destroy';

export const INIT_STATE = '[Master masterHome] Init State';
export const INIT_VALUE = '[Master masterHome] Init Value';
export const INIT_VALUE_SUCCESS = '[Master masterHome] Init Value Success';
export const INIT_VALUE_FAIL = '[Master masterHome] Init Value Fail';

export const UPDATE_DATA = "[Master masterHome] Update Data";




export const initAction = ngrxCreateAction(INIT_SCREEN, payload => payload);

export const destroyAction = ngrxCreateAction(DESTROY_SCREEN, payload => payload);






export const initStateAction = ngrxCreateAction(INIT_STATE,payload => payload);

export const initValueAction = ngrxCreateAction(INIT_VALUE,payload => payload);

export const initValueSuccessAction = ngrxCreateAction(INIT_VALUE_SUCCESS,payload => payload);

export const initValueFailAction = ngrxCreateAction(INIT_VALUE_FAIL,payload => payload);





export const updateDataAction = ngrxCreateAction(
  UPDATE_DATA,
  payload => payload
);

